import { gql } from "@apollo/client";

export const GET_TICKET_MESSAGES = gql`
  query GetTicketMessages($input: TicketMessagesInput!) {
    getTicketMessages(input: $input) {
      messages {
        _id
        content
        attachments
        senderType
        isRead
        createdAt
        updatedAt
      }
      ticket {
        _id
        title
        description
        status
        createdAt
        user {
          _id
          name
        }
      }
      page
      totalPages
      docsCount
    }
  }
`;

export const CREATE_TICKET_MESSAGE = gql`
  mutation CreateMessage($messageInput: MessageInput!) {
    createMessage(messageInput: $messageInput) {
      _id
      content
      attachments
      senderType
      isRead
      ticket
      createdAt
      updatedAt
    }
  }
`;
